// #SortBy hide children <option> has value = "best-selling", "title-ascending", "title-descending", "price-descending", "created-ascending"
document.addEventListener('DOMContentLoaded', function () {
  const SortBy = document.getElementById('SortBy');
  const options = SortBy.children;
  const noneDisplayOptions = [
    'best-selling',
    'title-ascending',
    'title-descending',
    'price-descending',
    'created-ascending',
  ];
  for (let i = 0; i < options.length; i++) {
    const option = options[i];
    if (noneDisplayOptions.includes(option.value)) {
      option.style.display = 'none';
    }
  }
});
